import React, { FC, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { API } from 'core/API';

import { DeleteOpportunityRequest, ADMIN_SEARCH_FILTER_TYPE } from '@joc/api-gateway';

import PopupConfirmation from 'shared/components/PopupConfirmation';
import ButtonTrash from 'shared/components/Buttons/ButtonTrash';

import { SnackbarError } from 'shared/components/_Snackbars';

import { SUPER_ADMIN_OPPORTUNITIES_QUERY_KEY } from '../hooks/useSuperAdminOpportunities';

type SuperAdminPrivateDeleteButtonNewProps = {
	opportunityId: number;
	opportunityFilterType: ADMIN_SEARCH_FILTER_TYPE;
};

const SuperAdminPrivateDeleteButtonNew: FC<SuperAdminPrivateDeleteButtonNewProps> = ({
	opportunityId,
	opportunityFilterType,
}: SuperAdminPrivateDeleteButtonNewProps) => {
	const queryClient = useQueryClient();
	const [isShowConfirmation, setIsShowConfirmation] = useState(false);
	const [isShowError, setIsShowError] = useState(false);
	const [errorMessage, setErrorMessage] = useState<string>('Something went wrong.');

	const invalidateList = () => {
		queryClient.invalidateQueries({
			queryKey: [SUPER_ADMIN_OPPORTUNITIES_QUERY_KEY, opportunityFilterType],
			exact: false,
		});
	};

	const deleteClickHandler = async () => {
		try {
			await API.deleteOpportunity(opportunityId, DeleteOpportunityRequest.fromJS(undefined));
			invalidateList();
		} catch (e: any) {
			setErrorMessage(e?.response?.message || e?.message || 'Something went wrong.');
			setIsShowError(true);
		} finally {
			setIsShowConfirmation(false);
		}
	};

	return (
		<>
			<ButtonTrash clickHandler={() => setIsShowConfirmation(true)} />

			{isShowConfirmation && (
				<PopupConfirmation
					confirmClickHandler={deleteClickHandler}
					cancelClickHandler={() => setIsShowConfirmation(false)}
					setIsShowPopup={setIsShowConfirmation}
				/>
			)}

			<SnackbarError open={isShowError} onClose={setIsShowError} message={errorMessage} width={320} />
		</>
	);
};

export default SuperAdminPrivateDeleteButtonNew;
